<template>
  <div>
    <div class="grid">
      <div class="grid-title">
        <div class="row">
          <div class="col-md-6">
            <h4>Stock and Pieces Overridden</h4>
          </div>
          <div class="col-md-6 text-right">
            <button
              class="btn btn-primary"
              @click="showCreateOverrideDialog"
              v-if="!isReadOnlyUser"
            >
              <i class="fa fa-plus-circle" aria-hidden="true"></i> Add Override
            </button>
          </div>
        </div>
      </div>
      <div class="grid-body">
        <vue-good-table
          mode="remote"
          ref="override_table"
          :totalRows="totalRecords"
          styleClass="table table-bordered"
          :pagination-options="{
            enabled: true,
            mode: 'pages',
          }"
          :columns="columns"
          :rows="rows"
        >
          <template slot="table-row" slot-scope="props">
            <span v-if="props.column.field == 'action'">
              <a
                class="btn btn-sm btn-primary"
                @click="showUpdateOverrideDialog(props.row)"
                v-if="!isReadOnlyUser"
              >
                Update Override
              </a>
              <a
                class="btn btn-sm btn-danger"
                @click="deleteOverride(props.row)"
                v-if="!isReadOnlyUser"
              >
                Delete Override
              </a>
            </span>
            <span v-else-if="props.column.field == 'reserved_stock'">
              {{ props.formattedRow[props.column.field] ? props.formattedRow[props.column.field].toFixed(2) : 0 }} m
            </span>
            <span v-else>
              {{ props.formattedRow[props.column.field] }}
            </span>
          </template>
        </vue-good-table>
      </div>
    </div>

    <!-- Modal -->
    <div
      class="modal fade"
      id="modal-box"
      tabindex="-1"
      role="dialog"
      aria-labelledby="modelTitleId"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title text-bold" v-if="editId != null">
              Update Override
            </h5>
            <h5 class="modal-title text-bold" v-else>New Override</h5>
          </div>
          <div class="modal-body bg-white">
            <div class="form-group" v-if="editId == null">
              <label>Fabric ID </label>
              <v-select
                class="select-fabric"
                :options="fabrics"
                :reduce="(fabric) => fabric.id"
                label="production_name"
                v-model="formData.fabric_id"
                placeholder="Select Fabric"
              />
              <small
                v-if="errors.fabric_id"
                class="form-text text-danger"
              >
                {{ errors.fabric_id.join(" ") }}
              </small>
            </div>

            <div class="form-group">
              <label>Soon Sold Out Trigger </label>
              <input
                type="text"
                class="form-control"
                v-model="formData.soon_sold_out_trigger"
                placeholder="Soon Sold Out Trigger"
              />
              <small
                v-if="errors.soon_sold_out_trigger"
                class="form-text text-danger"
              >
                {{ errors.soon_sold_out_trigger.join(" ") }}
              </small>
            </div>

            <div class="form-group">
              <label>Sold Out Trigger </label>
              <input
                type="text"
                class="form-control"
                v-model="formData.sold_out_trigger"
                placeholder="Sold Out Trigger"
              />
              <small
                v-if="errors.sold_out_trigger"
                class="form-text text-danger"
              >
                {{ errors.sold_out_trigger.join(" ") }}
              </small>
            </div>

            <div class="form-group">
              <label>Pieces Available (leave blank if you do not wish to set!)</label>
              <input
                type="text"
                class="form-control"
                v-model="formData.count"
                placeholder="Pieces Available"
              />
              <small v-if="errors.count" class="form-text text-danger">
                {{ errors.count.join(" ") }}
              </small>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
            >
              Close
            </button>
            <button
              type="button"
              class="btn btn-primary"
              v-if="editId != null"
              @click="updateOverride()"
            >
              Update
            </button>
            <button
              type="button"
              class="btn btn-primary"
              v-else
              @click="createOverride()"
            >
              Create
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- modal -->
  </div>
</template>

<script>
import { TableHelper } from "@/pages/Tools/TableHelper.js";
import { VueGoodTable } from "vue-good-table";
export default {
  name: "AvailabilityOverrideFabrics",
  components: {
    VueGoodTable,
  },
  data() {
    return {
      totalRecords: 0,
      rows: [],
      fabrics: [],
      formData: {},
      errors: {},
      editId: null,
      isReadOnlyUser: false,
      serverParams: {
        page: 1,
        perPage: 10,
        orderBy: { column: "fabric_id", type: "desc" },
      },
      columns: [
        {
          label: "Fabric ID",
          field: "fabric_id",
          tdClass: "text-left",
          thClass: "text-left",
        },
        {
          label: "Fabric Name",
          field: "fabric_name",
          tdClass: "text-left",
          thClass: "text-left",
        },
        {
          label: "Soon Sold Out Trigger",
          field: "soon_sold_out_trigger",
          tdClass: "text-center",
          thClass: "text-center",
        },
        {
          label: "Sold Out Trigger",
          field: "sold_out_trigger",
          tdClass: "text-center",
          thClass: "text-center",
        },
        {
          label: "Pieces Available",
          field: "count",
          tdClass: "text-center",
          thClass: "text-center",
        },
        {
          label: "Reserved Stock",
          field: "reserved_stock",
          tdClass: "text-center",
          thClass: "text-center",
        },
        {
          label: "Current Status",
          field: "fabric_status",
          tdClass: "text-center",
          thClass: "text-center",
        },
        {
          label: "",
          field: "action",
          tdClass: "text-right",
          thClass: "text-right",
          sortable: false,
        },
      ],
    };
  },
  mounted() {
    this.isReadOnlyUser = this.$auth.user().role === "read_only";
    this.tableHelper = new TableHelper({
      parent: this,
      endpoint: "/v2/fabrics/availability_override/pieces",
      sort: {
        fabric_id: "asc",
      },
    });
    this.getFabrics();
  },
  methods: {
    async getFabrics() {
      let res = await axios.get("/v2/fabrics?as_dropdown=1");
      this.fabrics = res.data.data.collection;
    },

    showCreateOverrideDialog() {
      this.editId = null;
      this.errors = {};
      this.formData = {};
      show_modal("#modal-box");
    },

    showUpdateOverrideDialog(override) {
      this.errors = {};
      this.formData = {
        fabric_id: override.fabric_id,
        soon_sold_out_trigger: override.soon_sold_out_trigger,
        sold_out_trigger: override.sold_out_trigger,
        count: override.count,
      };
      this.editId = override.id;
      show_modal("#modal-box");
    },

    async createOverride() {
      if(isNaN(parseInt(this.formData.count))) {
        // delete the count param if the user didn't supply a value
        delete this.formData['count'];
      }
      try {
        let res = await axios.post(
          "v2/fabrics/availability_override/pieces",
          this.formData
        );
        if (res) {
          this.tableHelper.reloadData();
          toastr.success("Success");
          hide_modal("#modal-box");
        }
      } catch (error) {
        if (error.response.status === 403) {
          toastr.error(
            "Not authorized, please ensure that you have the required permissions."
          );
        } else {
          this.errors = error.response.data.errors;
          toastr.error(error.response.data.message);
        }
      }
    },

    async updateOverride() {
      if(isNaN(parseInt(this.formData.count))) {
        // delete the count param if the user didn't supply a value
        delete this.formData['count'];
      }
      try {
        let res = await axios.put(
          "v2/fabrics/availability_override/pieces/" + this.editId,
          this.formData
        );
        if (res) {
          this.tableHelper.reloadData();
          toastr.success("Success");
          hide_modal("#modal-box");
        }
      } catch (error) {
        if (error.response.status === 403) {
          toastr.error(
            "Not authorized, please ensure that you have the required permissions."
          );
        } else {
          this.errors = error.response.data.errors;
          toastr.error(error.response.data.message);
        }
      }
    },

    async deleteOverride(override) {
      let result = await Swal.fire({
        title: "Are you sure to Delete?",
        type: "warning",
        showCancelButton: true,
        cancelButtonText: "NO",
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "DELETE",
      });

      if (!result.value) {
        return;
      }
      try {
        let res = await axios.delete(
          "v2/fabrics/availability_override/pieces/" + override.id
        );
        if (res) {
          this.tableHelper.reloadData();
          toastr.success("SUCCESS");
        }
      } catch (error) {
        if (error.response.status === 403) {
          toastr.error(
            "Not authorized, please ensure that you have the required permissions."
          );
        } else {
          toastr.error(
            "Unable to delete this override, contact the admins for help!"
          );
        }
      }
    },
  },
};
</script>

<style scoped>
</style>
